import { render } from "./UserDetails.vue?vue&type=template&id=39ced17c&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"

import "./UserDetails.vue?vue&type=style&index=0&id=39ced17c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39ced17c"

export default script